import DynamicFormPopup from "Components/Popup/DynamicFormPopup";
import { Row } from "react-bootstrap";
import HL7ModalDef from "./HL7ModalDef";
import { Fragment } from "react";

// HL7 modal for repo details page
function HL7Modal({ setShowModal, showModal}) {

    return (
        <Row id="compare-popup" >
            <DynamicFormPopup
                key={"hl7-popup"}
                showPopup = {showModal}
                handleClose = {()=>setShowModal(false)}
                buttons = {[{
                    text: "Close",
                    action: ()=>setShowModal(false),
                    variant: "comp-primary",
                    size: "lg",
                    className: "m-0 close-compare-btn w-xs-100 w-md-fit-content"
                }]}
                title = {"HL7 Data Type"}
                type= {"blank"}
                variant={"blank"}
                className=""
                id="compare-popup hl7-popup"
                size="xl"
                closeVar="repo"
                scrollable={false}
            >
                <Fragment key="hl7-modal-key">                
                    <p className="color-base-darkergray mb-0">The HL7 data type for the answer values that are collected. For more information please review the <a className="external-link" target="_blank" href="https://build.fhir.org/ig/HL7/CDA-core-sd/artifacts.html">HL7 Artifacts Summary</a>.</p>
                    
                    {/* HL7 Definitions */}
                    <div className="definitions gap-0px gap-md-24px">
                        <HL7ModalDef 
                            key={"CD"}
                            defKey={"Concept Descriptor (CD)"}
                            value={`A concept descriptor represents any kind of concept usually by giving a code defined in a code system. A concept descriptor can contain the original text or phrase that served as the basis of the coding and one or more translations into different coding systems. A concept descriptor can also contain qualifiers to describe, e.g., the concept of a "left foot" as a postcoordinated term built from the primary code "FOOT" and the qualifier "LEFT". In exceptional cases, the concept descriptor need not contain a code but only the original text describing that concept.`}
                            shortValue={`A concept descriptor represents any kind of concept usually by giving a code defined in a code system.`}
                        />
                        <HL7ModalDef 
                            key={"ED"}
                            defKey={`Encapsulated Data (ED)`}
                            value={`Data that is primarily intended for human interpretation or for further machine processing outside the scope of HL7. This includes unformatted or formatted written language, multimedia data, or structured information in as defined by a different standard (e.g., XML-signatures.) Instead of the data itself, an may contain only a reference. Note that the data type is a specialization of the data type when the media type is text/plain.`}
                            shortValue={`Data that is primarily intended for human interpretation or for further machine processing outside the scope of HL7.`}
                        />
                        <HL7ModalDef 
                            key={"INT"}
                            defKey={`Integer Number (INT)`}
                            value={`Integer numbers (-1,0,1,2, 100, 3398129, etc.) are precise numbers that are results of counting and enumerating. Integer numbers are discrete, the set of integers is infinite but countable. No arbitrary limit is imposed on the range of integer numbers. Two NULL flavors are defined for the positive and negative infinity.`}
                            shortValue={`Integer numbers (-1,0,1,2, 100, 3398129, etc.) are precise numbers that are results of counting and enumerating. Integer numbers are discrete, the set of integers is infinite but countable.`}
                        />
                        <HL7ModalDef 
                            key={"PN"}
                            defKey={`Person Name (PN)`}
                            value={`A name for a person. A sequence of name parts, such as given name or family name, prefix, suffix, etc. Examples for person name values are "Jim Bob Walton, Jr.", "Adam Everyman", etc. A person name may be as simple as a character string or may consist of several person name parts, such as, "Jim", "Bob", "Walton", and "Jr.". PN differs from EN because the qualifier type cannot include LS (Legal Status).`}
                            shortValue={`A name for a person. A sequence of name parts, such as given name or family name, prefix, suffix, etc.`}
                        />
                        <HL7ModalDef 
                            key={"PQ"}
                            defKey={`Physical Quantity (PQ)`}
                            value={`A dimensioned quantity expressing the result of measuring.`}
                            shortValue={null}
                        />
                        <HL7ModalDef 
                            key={"TS"}
                            defKey={`Point In Time (TS)`}
                            value={`A quantity specifying a point on the axis of natural time. A point in time is most often represented as a calendar expression.`}
                            shortValue={null}
                        />
                        <HL7ModalDef 
                            key={"ETL"}
                            defKey={`Telecommunication Address (ETL)`}
                            value={`A telephone number (voice or fax), e-mail address, or other locator for a resource mediated by telecommunication equipment. The address is specified as a Universal Resource Locator (URL) qualified by time specification and use codes that help in deciding which address to use for a given time and purpose.`}
                            shortValue={`A telephone number (voice or fax), e-mail address, or other locator for a resource mediated by telecommunication equipment.`}
                        />
                    </div>
                </Fragment>
            </DynamicFormPopup>
        </Row>
    );
}

export default HL7Modal;